exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tf_title_dialog[data-v-5d2c997f] {\n  text-overflow: ellipsis;\n  width: calc(100% - 180px);\n  overflow: hidden;\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5d2c997f","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheezy/WzDialogAnalyseChat.vue
// module id = Z66U
// module chunks = 1